import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    const {
      submenuSelector,
      submenuTogglerSelector,
      menuTogglerSelector,
      menuContainerSelector,
      searchTogglerSelector,
      searchContainerSelector
    } = config;

    this.body = document.querySelector("body");
    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.submenuSelector = submenuSelector;
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.searchToggler = document.querySelector(searchTogglerSelector);
    this.searchContainer = document.querySelector(searchContainerSelector);
    this.searchOpen = false;
    this.submenuOpen = false;
    this.menuOpen = false;

    if (this.submenuToggler) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.menuToggler.addEventListener("click", e => {
      this.toggleMenu();
    });
    this.searchToggler.addEventListener("click", e => {
      this.toggleSearch();
    });
    this.subTogglerArray.forEach(toggle => {
      toggle.addEventListener("click", e => {
        e.preventDefault();
        this.toggleSubmenu(toggle);
      });
    });
  }
  toggleSearch() {
    if (this.searchOpen) {
      Helper.removeClass(this.menuToggler, "burger-active");
      Helper.slideUp(this.searchContainer);
      Helper.removeClass(this.body, "search-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.searchOpen = false;
    } else {
      if (this.menuOpen) {
        this.toggleMenu();
      }
      this.closeAllSubmenus();
      Helper.addClass(this.menuToggler, "burger-active");
      Helper.slideDown(this.searchContainer);
      Helper.addClass(this.body, "search-open");
      this.searchContainer.querySelector("input").focus();
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.toggleSearch();
        });
      }
      this.searchOpen = true;
    }
  }
  toggleMenu() {
    if (this.searchOpen) {
      this.toggleSearch();
    } else {
      if (this.menuOpen) {
        Helper.removeClass(this.menuToggler, "burger-active");
        Helper.slideUp(this.menuContainer);
        Helper.removeClass(this.body, "menu-open");
        if (document.querySelector(".header-backdrop")) {
          document.querySelector(".header-backdrop").remove();
        }
        this.menuOpen = false;
      } else {
        Helper.addClass(this.menuToggler, "burger-active");
        Helper.slideDown(this.menuContainer);
        Helper.addClass(this.body, "menu-open");
        if (!document.querySelector(".header-backdrop")) {
          let backdrop = document.createElement("div");
          Helper.addClass(backdrop, "header-backdrop");
          this.body.appendChild(backdrop);
          backdrop.addEventListener("click", () => {
            this.toggleMenu();
          });
        }
        this.menuOpen = true;
      }
    }
  }

  closeAllSubmenus() {
    console.log("close all submenus");
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    Helper.removeClass(this.body, "submenu-open");
    submenus.forEach(submenu => {
      Helper.slideUp(submenu);
      Helper.removeClass(submenu.parentElement, "submenu-open");
    });
    if (document.querySelector(".header-backdrop")) {
      document.querySelector(".header-backdrop").remove();
    }
    this.submenuOpen = false;
  }

  toggleSubmenu(toggle) {
    if (this.searchOpen) {
      this.toggleSearch();
    }
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    const currentSubmenu = toggle.nextElementSibling;
    Helper.slideToggle(currentSubmenu);
    Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");
    submenus.forEach(submenu => {
      if (submenu != currentSubmenu) {
        Helper.slideUp(submenu);
        Helper.removeClass(submenu.parentElement, "submenu-open");
      }
    });
    submenus.forEach(submenu => {
      if (Helper.hasClass(submenu.parentElement, "submenu-open")) {
        this.submenuOpen = true;
      }
    });
    if (this.submenuOpen) {
      Helper.addClass(this.body, "submenu-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.closeAllSubmenus();
        });
      }
      this.submenuOpen = false;
    } else {
      Helper.removeClass(this.body, "submenu-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.submenuOpen = true;
    }
  }
}
export default Header;
